// extracted by css-extract-rspack-plugin
export default {"favicon":"oH9SO7VWAtImJcG8"};